export const FindRecipeMockData = [
  {
    id: 1,
    value: 'breakfast',
    name: 'Breakfast',
  },
  {
    id: 2,
    value: 'lunch',
    name: 'Lunch',
  },
  {
    id: 3,
    value: 'dinner',
    name: 'Dinner',
  },
  {
    id: 4,
    value: 'breakfast',
    name: 'Juices/Shakes',
    dishType: 'drinks'
  },
];
